<template>
    <CategoryForm :url="url" :model="model" :errors="errors" v-on:save="saveCategory"></CategoryForm>
</template>

<script>
import CategoryForm from './CategoryForm'
export default {
  name: 'CategoryEdit',
  components: {CategoryForm},
  props: ['url'],
  data () {
    return {
      model: {},
      errors: {}
    }
  },
  methods: {
    saveCategory () {
      let self = this

      this.$http
        .put(this.url + `/update/${this.$route.params.id}`, this.model, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.model = res.data.data
            this.$router.push('/admin/categories/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Category Edit'))

    let self = this
    this.$http
      .get(this.url + `/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.model = res.data.data
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/category/CategoryEdit.vue